import { createContext } from "react"

const shadowRootContext = createContext<ShadowRoot | null>(null)

export const ShadowRootProvider = ({ children, value }: { children: React.ReactNode; value: ShadowRoot }) => {
  return <shadowRootContext.Provider value={value}>{children}</shadowRootContext.Provider>
}

export default shadowRootContext
